import getThemes from './themes';

const getTheme = (state, themeId) => {
  const themes = getThemes(state);
  return themes.find((theme) => theme.id === themeId) || null;
};

export default getTheme;
